import { useContext } from "react";
import "./card-modal.css"
import { AuthContext } from "../../utils/AuthContext";
import { addCardToUserDocument, addLikedCardToUserDocument, addWishlistedCardToUserDocument, removeCardFromUserDocument, UnlikeCardFromUserDocument, UnwishlistCardFromUserDocument } from "../../firebase";

export default function CardModal({ cardData, setModal, ownedCards = [], setUserInfo, likedCards = [], wishlistedCards = [] }) {

    const { authState } = useContext(AuthContext);
    
    const handleAddCard = (e, cardID) => {
        e.stopPropagation();
        addCardToUserDocument(authState.uid, cardID).then(() => {
            setUserInfo((prevUserInfo) => ({
                ...prevUserInfo,
                owned_cards: [...prevUserInfo.owned_cards, cardID],
            }));
        })
    }
    
    const handleLikeCard = (e, cardID) => {
        e.stopPropagation();
        addLikedCardToUserDocument(authState.uid, cardID).then(() => {
            setUserInfo((prevUserInfo) => ({
                ...prevUserInfo,
                liked_cards: [...prevUserInfo.liked_cards, cardID],
            }));
        })
    }
    
    const handleWishlistCard = (e, cardID) => {
        e.stopPropagation();
        addWishlistedCardToUserDocument(authState.uid, cardID).then(() => {
            setUserInfo((prevUserInfo) => ({
                ...prevUserInfo,
                wishlisted_cards: [...prevUserInfo.wishlisted_cards, cardID],
            }));
        })
    }

    const handleRemoveCard = (e, cardID) => {
        e.stopPropagation();
        removeCardFromUserDocument(authState.uid, cardID).then(() => {
            setUserInfo((prevUserInfo) => ({
                ...prevUserInfo,
                owned_cards: prevUserInfo.owned_cards.filter((id) => id !== cardID),
            }));
        });
    };

    const handleUnlikeCard = (e, cardID) => {
        e.stopPropagation();
        UnlikeCardFromUserDocument(authState.uid, cardID).then(() => {
            setUserInfo((prevUserInfo) => ({
                ...prevUserInfo,
                liked_cards: prevUserInfo.liked_cards.filter((id) => id !== cardID),
            }));
        });
    };

    const handleUnwishlistCard = (e, cardID) => {
        e.stopPropagation();
        UnwishlistCardFromUserDocument(authState.uid, cardID).then(() => {
            setUserInfo((prevUserInfo) => ({
                ...prevUserInfo,
                wishlisted_cards: prevUserInfo.wishlisted_cards.filter((id) => id !== cardID),
            }));
        });
    };

    return (
        <div className="modal-overlay" onClick={() => setModal(false)}>
            <div className="card-modal" onClick={(e) => e.stopPropagation()}>
                <div className="card-image">
                    {cardData.card_image ? (
                        <img src={cardData.card_image} alt={cardData.card_name} />
                    ) : (
                        <img src={`${process.env.PUBLIC_URL}/assets/placeholder.jpg`} alt={cardData.card_name} />
                    )}
                    
                </div>
                <div className="card-data">

                    {!ownedCards.includes(cardData.card_image_id) && <button className="mobile-button add-card cta" onClick={(e) => handleAddCard(e, cardData.card_image_id)}>Add to my collection</button>}
                    {ownedCards.includes(cardData.card_image_id) && <button className="mobile-button remove-card cta" onClick={(e) => handleRemoveCard(e, cardData.card_image_id)}>Remove from my collection</button>}

                    {!likedCards.includes(cardData.card_image_id) && <button className="mobile-button add-card cta like" onClick={(e) => handleLikeCard(e, cardData.card_image_id)}>Like this card</button>}
                    {likedCards.includes(cardData.card_image_id) && <button className="mobile-button remove-card cta like" onClick={(e) => handleUnlikeCard(e, cardData.card_image_id)}>Unlike this card</button>}

                    {!wishlistedCards.includes(cardData.card_image_id) && <button className="mobile-button add-card cta wishlist" onClick={(e) => handleWishlistCard(e, cardData.card_image_id)}>Add to my wishlist</button>}
                    {wishlistedCards.includes(cardData.card_image_id) && <button className="mobile-button remove-card cta wishlist" onClick={(e) => handleUnwishlistCard(e, cardData.card_image_id)}>Remove from my wishlist</button>}
                    
                    <h2>{cardData.card_name}</h2>
                    <p><b>Card type : </b>{cardData.card_type}</p>
                    <p><b>Group : </b>{cardData.sub_types}</p>
                    <p><b>Set : </b>{cardData.set_name}</p>
                    <p><b>Card text : </b>{cardData.card_text}</p>
                    <p><b>Card ID : </b>{cardData.card_set_id}</p>
                    <p><b>Card rarity : </b>{cardData.rarity}</p>
                    <p><b>Card color : </b>{cardData.card_color}</p>
                    <p><b>Card cost : </b>{cardData.card_cost}</p>
                    <p><b>Card power : </b>{cardData.card_power}</p>
                    <p><b>Counter amount : </b>{cardData.counter_amount}</p>
                    <p><b>Inventory price : </b>${cardData.inventory_price}</p>
                    <p><b>Market price : </b>${cardData.market_price}</p>

                    {!ownedCards.includes(cardData.card_image_id) && <button className="desktop-button add-card cta" onClick={(e) => handleAddCard(e, cardData.card_image_id)}>Add to my collection</button>}
                    {ownedCards.includes(cardData.card_image_id) && <button className="desktop-button remove-card cta" onClick={(e) => handleRemoveCard(e, cardData.card_image_id)}>Remove from my collection</button>}

                    {!likedCards.includes(cardData.card_image_id) && <button className="desktop-button add-card cta like" onClick={(e) => handleLikeCard(e, cardData.card_image_id)}>Like this card</button>}
                    {likedCards.includes(cardData.card_image_id) && <button className="desktop-button remove-card cta like" onClick={(e) => handleUnlikeCard(e, cardData.card_image_id)}>Unlike this card</button>}

                    {!wishlistedCards.includes(cardData.card_image_id) && <button className="desktop-button add-card cta wishlist" onClick={(e) => handleWishlistCard(e, cardData.card_image_id)}>Add to my wishlist</button>}
                    {wishlistedCards.includes(cardData.card_image_id) && <button className="desktop-button remove-card cta wishlist" onClick={(e) => handleUnwishlistCard(e, cardData.card_image_id)}>Remove from my wishlist</button>}

                </div>
                <div className="close-modal" onClick={() => setModal(false)}>
                    <img src={`${process.env.PUBLIC_URL}/assets/304947.svg`} alt="close" height="30" width="30"/>
                </div>
            </div>
        </div>
    )
}